import React from "react";
import PropTypes from "prop-types";
import styles from "./TagFilter.module.css";

/**
 * Filtro secundário por tag (F2.5). `<select>` nativo — acessível e navegável
 * por teclado sem lib nova. Combina com a aba de fila (primário) e com o chip de
 * canal: o filtro é aplicado client-side ANTES da contagem por fila, então as
 * abas refletem o subconjunto da tag selecionada (facetado, consistente com o
 * canal). "Todas as tags" limpa o filtro.
 *
 * Opções = união das tags presentes nas sessões carregadas. Se nada há para
 * filtrar e não há filtro ativo, o controle não renderiza.
 */
export default function TagFilter({ tags, value, onChange }) {
  if (tags.length === 0 && !value) return null;

  // Garante que a tag ativa continue selecionável mesmo se sumiu das sessões
  // carregadas (ex.: última conversa com ela mudou de aba).
  const options = value && !tags.includes(value) ? [value, ...tags] : tags;

  return (
    <div className={styles.wrap}>
      <label htmlFor="tag-filter" className={styles.label}>
        Tag
      </label>
      <select
        id="tag-filter"
        className={styles.select}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value || null)}
      >
        <option value="">Todas as tags</option>
        {options.map((t) => (
          <option key={t} value={t}>
            {t}
          </option>
        ))}
      </select>
    </div>
  );
}

TagFilter.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
